import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "../../API/axios";
import { people, svg } from "../../config/imagesLink";
import MessageInteraction from "./MessageInteraction";
import PushPinSharpIcon from '@mui/icons-material/PushPinSharp';
import CircleIcon from '@mui/icons-material/Circle';
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getChatUnreadCount } from "../../utils/chatReadUtils";

const { pin } = svg;

const MessageList = ({
  showClear,
  setShowClear,
  showDelete,
  setShowDelete,
  isShown,
  getChatList,
  archiveMessage,
  item,
  index,
  active,
  setActive,
  setToUserId,
  UserId,
  setMsgId,
  getArchivedList,
  getMessageList,
  setIsShown,
  setChatList
}) => {
  console.log("iteeem", item);
  const sessionId = localStorage.getItem("sessionId");
  const [archivedList, setArchivedList] = useState([]);
  const { t } = useTranslation();
  //const formattedTime = moment(item.lastMsgTime).fromNow();
  //const formattedTime = {moment.utc(item.lastMsgTime).local().format("LT")}
  // console.log(item);


  const getDisplayDate = (date) => {
    const today = moment().startOf('day');
    const msgDate = moment(date).startOf('day');
  
    if (msgDate.isSame(today, 'day')) {
      return t("Notifications.Today");
    } else if (msgDate.isSame(today.clone().subtract(1, 'day'), 'day')) {
      return t("Notifications.Yesterday");
    } else if (msgDate.isAfter(today.clone().subtract(6, 'day'))) {
      return msgDate.format("dddd"); // Monday, Tuesday, etc.
    } else {
      return msgDate.format("DD-MM-YYYY"); // e.g. 12 Jul 2025
    }
  };

  const getUserImage = (image) =>
    !image || image === "" ? people.DefaultProfile : image;

  const handleImageError = (e) => {
    e.target.src = people.DefaultProfile;
  };

  const isBlockedByYou =
    item.chatInfo?.isBlockedByYou === true || item.isBlockedByYou === true;

  const unreadCount = getChatUnreadCount(item);
  const isCurrentChat =
    UserId &&
    UserId !== "All" &&
    String(item.chatInfo?.toUserUid) === String(UserId);
  const showUnreadBadge = unreadCount > 0 && !isCurrentChat;
  const unreadBadgeLabel = unreadCount > 99 ? "99+" : unreadCount;

  return (
    <>
      <Link to={`/Message/${item?.chatInfo?.toUserUid}`} onClick={() => { }}>
        <div
          onClick={() => {
            setActive(index);
            // setToUserId(item.chatInfo.toUserUid)
            setMsgId(item.chatInfo.msgID);
            setIsShown(current => !current)
          }}
          className={`${isShown ? "d-block" : "d-md-block d-none"} pointer`}
        >
          <div
            key={index}
            className={`${active === index ? "activeMsg" : ""
              } message-cards d-flex align-items-center mb-2`}
              style={{ height : "70px"}}
          >
            {/* <div className="empty-msg-card ms-3 me-3"></div> */}
            <div className="me-3 ms-2 d-flex">
              <img
                src={getUserImage(item.chatInfo?.toUserImage)}
                onError={handleImageError}
                alt=""
                width={40}
                height={40}
                style={{ borderRadius: "50px" }}
              />
              {item.chatInfo.toUserIsOnline === true ? (
                <>
              <div style={{position:'relative', left:'-10px', top: '-6px'}}>
                   <CircleIcon style={{ color:' 29cd29',
                //  fontSize:'14px',
                 background :' rgb(41, 205, 41)',
                                        borderRadius:' 50%',
                                        width: '11px',
                                        height: '11px',
                                        border: '1px solid white',                    
                                        boxShadow: '1px 1px 6px 1px white',
                  }}/>
                </div>
                </>
              ): ''}
            </div>
            <div className="msg-content w-100 me-2">
              <div className="name-time d-flex justify-content-between align-items-baseline">
                <div className="message-user-name darkmode f-12 f-600">
                  {/* {item.chatInfo.toUserFullName}{" "} */}
                    {(item.chatInfo.toUserFullName?.length > 20 ? item.chatInfo.toUserFullName.slice(0, 20) + "..." : item.chatInfo.toUserFullName)}

                  {/* {item?.isPined ?
                    <img src={pin} width={20} /> : ""}{" "} */}
                </div>
                <div
                  className={`message-time darkmode f-10 f-400 ${
                    showUnreadBadge ? "message-time-unread" : ""
                  }`}
                >
                    <Tooltip
                      title={ <p className="text-light">
                       {moment.utc(item.lastMsgTime).local().format("DD MMMM YYYY")}
                        </p>  } arrow  >
                  {/* {moment.utc(item.lastMsgTime).local().format("LT")} */}
													 {getDisplayDate(item.lastMsgTime)}
                           </Tooltip>

                </div>
              </div>
              <div className="d-flex justify-content-between">
                <div
                  className={`${item.lastMsgIsRead === false
                    ? "fw-bolder f-14"
                    : "fw-normal f-10"
                    } messageText darkmode `}
                >

                  <p className="messageText">
                    {isBlockedByYou ? (
                      <span className="text-muted f-10">
                        {t("Newsfeed.Want to continue chat with this user")}{" "}
                        {t("Newsfeed.Unblock from settings")}
                      </span>
                    ) : (
                      <>
                        {item?.isOwned && `${t("Notifications.You")}:  `}
                        {(item.lastMsg?.length > 20 ? item.lastMsg.slice(0, 20) + "..." : item.lastMsg)}
                      </>
                    )}
                  </p>
                </div>
                <div className="d-flex align-items-center">
                  {showUnreadBadge ? (
                    <span
                      className={`msg-unread-badge ${
                        unreadCount > 9 ? "msg-unread-badge-wide" : ""
                      }`}
                    >
                      {unreadBadgeLabel}
                    </span>
                  ) : null}
                  {item.isPined === true ? (
                    <PushPinSharpIcon className="material-symbols-sharp " style={{fontSize:'12px !important'}} />
                  ) : (
                    ""
                  )} 
                  <div
                    // onClick={(e) => e.stopPropagation()}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault(); // Prevents Link's default navigation
                    }}
                  >

                    <MessageInteraction
                      // showClear={showClear}
                      // setShowClear={setShowClear}
                      // showDelete={showDelete}
                      // setShowDelete={setShowDelete}
                      chatId={item.chatID}
                      isRead={item.lastMsgIsRead}
                      isPined={item.isPined}
                      getChatList={getChatList}
                      archiveMessage={archiveMessage}
                      usermsgId={item.chatInfo.msgID}
                      UserId={item.chatInfo.toUserUid}
                      getArchivedList={getArchivedList}
                      getMessageList={getMessageList}
                      toUserUId={item.chatInfo.toUserUid}
                      setChatList={setChatList}
                    />

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </>
  );
};

export default MessageList;
